"use client";

import React from "react";
import BrandsSliderSection from "../components/BrandsSliderSection";
import HeroSection from "../components/HeroSection";
import ServicesCardSection from "../sections/api-development/ApiDevelopmentServicesCardSection";
import ProjectsShowcase from "../components/ProjectsShowcase";
import TechStackTabs from "../components/TechStackTabs";
import WhyChoose from "../components/WhyChoose";
import ExtraSectionsDispatcher from "../components/ExtraSectionsDispatcher";

import { useServiceData } from "../hooks/useServiceData";
import ApiAAS from "../sections/api-development/ApiAAS";
import ApiIntegrations from "../sections/api-development/ApiIntegrations";
import ApiSupport from "../sections/api-development/ApiSupport";

export default function ApiDevelopmentClient() {
  const { data: backendData } = useServiceData();
  const extraSections = backendData?.extraSections || [];

  // Find dynamic data for each section
  const apiAasData = extraSections.find(s => s.type === 'splitFeatureSection')?.refId;
  const integrationsData = extraSections.find(s => s.type === 'integrationSection')?.refId;
  // Note: ApiSupport might not be in extraSections yet, so it will use static defaults

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "API Development Services",
    serviceType: "API Development",
    provider: { "@type": "Organization", name: "CodeQlik" },
    areaServed: "Global",
    description:
      "Design, build, and scale secure APIs. REST & GraphQL, authentication, rate limiting, documentation, integrations, monitoring, and versioning.",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      {/* Hero section */}
      <HeroSection />
      {/* Brands slider */}
      <BrandsSliderSection />
      {/* Service cards */}
      <ServicesCardSection />
      
      {/* APIaaS overview (Dynamic with Static Fallback) */}
      <ApiAAS dynamicData={apiAasData} />

      {/* API Integrations (Dynamic with Static Fallback) */}
      <ApiIntegrations dynamicData={integrationsData} />

      {/* API Support (Static for now) */}
      <ApiSupport />
      
      {/* Projects section */}
      <ProjectsShowcase />
      {/* TechStackTabs section */}
      <TechStackTabs />
      {/* WhyChoose Section */}
      <WhyChoose />
    </>
  );
}
